import React, { ReactText, useState } from "react"
import ReactModal from "react-modal"
import tw, { styled, css } from "twin.macro"
import { navigate } from "gatsby"

// Utils
import { SlideProps } from "."
import { modalStyles } from "../utils/modalStyles"

// Components
import CloseIcon from "../svgs/closeIcon"
import Container from "../components/container"
import IconBrakes from "../icons/iconBrakes"
import IconDrivelines from "../icons/iconDrivelines"
import IconPetrolDiesel from "../icons/iconPetrolDiesel"
import IconSafety from "../icons/iconSafety"
import IconSuspension from "../icons/iconSuspension"
import IconTools from "../icons/iconTools"
import IconTyres from "../icons/iconTyres"
import LearnDetail from "../components/learnDetail"
import NextPageButton from "../components/nextPageButton"
import SlideSection from "../components/slideSection"
import TitleLearn from "../svgs/titleLearn"
import NextPageContainer from "../components/nextPageContainer"

interface TopicData {
  icon: React.FC
  description: ReactText
  details?: TopicDetails[]
}

interface TopicDetails {
  title?: string
  text: string[]
}

const topics: TopicData[] = [
  {
    icon: IconSafety,
    description:
      "Good work habits and safe work practices in the motor industry",
  },
  {
    icon: IconTools,
    description: "Tools and equipment used in the motor industry",
  },
  {
    icon: IconPetrolDiesel,
    description: "Petrol and diesel engines ",
  },
  {
    icon: IconDrivelines,
    description: "Drivelines and final drives",
  },
  {
    icon: IconSuspension,
    description: "Steering and suspension systems",
  },
  {
    icon: IconTyres,
    description: "Automotive tyres and wheels",
  },
  {
    icon: IconBrakes,
    description: "Brake systems",
  },
]

const Button = styled.button`
  padding: 0.2rem 1.05rem;
  ${tw`font-text tracking-normal text-sm bg-brand-blue rounded-sm text-white inline hover:bg-brand-hover-blue focus:outline-none py-2 px-4`}
`

const TrainNowSlide: React.SFC<SlideProps> = ({
  slideVisible,
  nextButtonClicked,
}) => {

  const startTrainingClicked = () => {
    navigate("/details")
  }

  const findApprenticeClicked = () => {
    window.location.href = "https://www.mito.org.nz/jobhub/";
  }

  return (
    <SlideSection autoHeightResponsive>
      <div css={[tw`flex flex-col items-center`]}>
        <div css={[tw`flex flex-col md:flex-row items-center justify-items-center`]}>
          <div css={[tw`flex flex-col items-center  mb-16 md:mb-0`]}>
            <Header css={[tw`text-4xl font-bold`, css`line-height: 1.2em; letter-spacing:-0.01em;`]}>
              {"Got someone\nto train?"}
            </Header>
            {/* <Description css={[tw`tracking-normal w-2/3`]}>
                Start talking to one of our Regional Training Advisers today.
              </Description> */}
            <Button
              onClick={startTrainingClicked}
            >Start training</Button>
          </div>
          <div css={[tw`md:w-32`]}></div>
          <div css={[tw`flex flex-col items-center md:mb-0`]}>
            <Header css={[tw`text-4xl font-bold`, css`line-height: 1.2em; letter-spacing:-0.01em;`]}>
              {"Looking for\nsomeone to train?"}
            </Header>
            {/* <Description css={[tw`tracking-normal w-2/3`]}>
                We have the largest pool of Automotive job seekers in the country listed on our Job Hub.
              </Description> */}
            <Button
              onClick={findApprenticeClicked}
            >Find an apprentice</Button>
          </div>
        </div>
      </div>

    </SlideSection>
  )
}

const LargeForceWrap = () => (
  <div
    css={[
      css`
        flex-basis: 100%;
        height: 0;
      `,
      tw`hidden lg:block`,
    ]}
  />
)

const Header = styled.h2`
  ${tw`md:block text-center font-sans text-2xl mb-6 whitespace-pre-wrap`}
`

const Description = styled.p`
  ${tw`text-center font-sans text-sm mb-6`}
`

export default TrainNowSlide
